// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicyEn_container__nCfi1","header":"privacyPolicyEn_header__E2xfx","updatedDate":"privacyPolicyEn_updatedDate__OHseg","list":"privacyPolicyEn_list__wpU9j"};